// @flow
import { DevicesGroupsActionTypes } from './constants';

type DevicesGroupsAction = { type: string, payload: {} | string };

// common success
export const devicesGroupsApiResponseSuccess = (actionType: string, data: any): DevicesGroupsAction => ({
    type: DevicesGroupsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const devicesGroupsApiResponseError = (actionType: string, error: string): DevicesGroupsAction => ({
    type: DevicesGroupsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getGroup = (id: string): DevicesGroupsAction => ({
    type: DevicesGroupsActionTypes.GET_GROUP,
    payload: { id },
});

export const addGroup = (group:any):DevicesGroupsAction=>({
    type:DevicesGroupsActionTypes.ADD_GROUP,
    payload:group
})
export const updateGroup = (group:any):DevicesGroupsAction=>({
    type:DevicesGroupsActionTypes.UPDATE_GROUP,
    payload:group
})
export const deleteGroup = (group:any):DevicesGroupsAction=>({
    type:DevicesGroupsActionTypes.DELETE_GROUP,
    payload:group
})

export const listGroups = (params:any): DevicesGroupsAction => ({
    type: DevicesGroupsActionTypes.LIST_GROUPS,
    payload: params,
});


export const resetGroups = (): DevicesGroupsAction => ({
    type: DevicesGroupsActionTypes.RESET,
    payload: {},
});

